export default __webpack_public_path__ + "static/media/notificationIcon.915f957c.svg";